import {Component} from 'react'
import {Switch, Route, Redirect} from 'react-router-dom'

import NxtWatchContext from './NxtWatchContext/NxtWatchContext'

import ProtectedRoute from './components/ProtectedRoute'
import Login from './components/Login'
import Home from './components/Home'
import TrendingRoute from './components/TrendingRoute'
import GamingRoute from './components/GamingRoute'
import SavedVideosRoute from './components/SavedVideosRoute'
import VideoItemDetailsRoute from './components/VideoItemDetailsRoute'
import NotFound from './components/NotFound'

import './App.css'

class App extends Component {
  state = {
    darkMode: false,
    savedVideosList: [],
    bannerStatus: true,
  }

  closeBanner = () => this.setState({bannerStatus: false})

  onClickSave = videoDetails => {
    const {savedVideosList} = this.state
    const {id} = videoDetails
    const isPresent = savedVideosList.some(eachItem => eachItem.id === id)
    if (isPresent) {
      const updatedList = savedVideosList.filter(eachItem => eachItem.id !== id)
      this.setState({savedVideosList: updatedList})
    } else {
      this.setState({savedVideosList: [...savedVideosList, videoDetails]})
    }
  }

  toggleTheme = () =>
    this.setState(prevState => ({
      darkMode: !prevState.darkMode,
    }))

  render() {
    const {darkMode, savedVideosList, bannerStatus} = this.state
    return (
      <NxtWatchContext.Provider
        value={{
          darkMode,
          savedVideosList,
          bannerStatus,
          closeBanner: this.closeBanner,
          onClickSave: this.onClickSave,
          toggleTheme: this.toggleTheme,
        }}
      >
        <Switch>
          <Route path="/login" component={Login} />
          <ProtectedRoute exact path="/" component={Home} />
          <ProtectedRoute exact path="/trending" component={TrendingRoute} />
          <ProtectedRoute exact path="/gaming" component={GamingRoute} />
          <ProtectedRoute
            exact
            path="/saved-videos"
            component={SavedVideosRoute}
          />
          <ProtectedRoute
            exact
            path="/videos/:id"
            component={VideoItemDetailsRoute}
          />
          <ProtectedRoute exact path="/not-found" component={NotFound} />
          <Redirect to="/not-found" />
        </Switch>
      </NxtWatchContext.Provider>
    )
  }
}

export default App
